<div class="card-footer">
    <app-migration-transactions [transactions]="mTransactions"></app-migration-transactions>

    <p class="mt-2 mb-1">
        Redeem Transactions
    </p>
    <div *ngIf="transactions?.data?.length > 0">
        <div *ngFor="let transaction of transactions?.data; let i = index">
            <div class="mb-2 d-flex justify-content-between align-center trxns">
                <span>
                    Swap {{transaction.amount / decimals}} BX Token from {{transaction.operation === 'ETH-BURN' ? 'Ethereum network' : 'Binance network'}}
                </span>
                <span>
                    <button [disabled]="loadingRedeem == i" class="btn btn-dark font-12 d-flex justify-content-center" (click)="redeem(transaction,i)">
                        <div *ngIf="loadingRedeem == i" class="loader"></div><span *ngIf="loadingRedeem != i">Redeem</span>
                        <span *ngIf="loadingRedeem == i">&nbsp; &nbsp;Please Wait...</span>
                    </button>
                </span> 
            </div>
        </div>  
        <!-- <pagination-controls (pageChange)="pageChanged($event)"></pagination-controls> -->
    </div>
    <div *ngIf="transactions?.data?.length === 0" class="d-flex justify-content-center mt-3">
        <h5>No transactions</h5>
    </div>
</div>

<!-- Modal -->
<div id="myModal" class="modal fade" role="dialog" [ngStyle]="{'display':display}">
    <div class="modal-dialog">
  
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header">
        </div>
        <div class="modal-body">
          <p>Some text in the modal.</p>
        </div>
      </div>
  
    </div>
  </div>
